import DisableAdditionModal from '@/components/additional/DisableAdditionModal.vue'
import { useComp } from './comp'

export const isAvailableAddition = async (data:any, fn:any) => {
  const additionReg = /addition/i
  const deliveryReg = /delivery/i
  const combinationReg = /combinationProductAdditionList/i
  const productAdt:any[] = []
  const delivery:any[] = []
  const combProductAdt:any[] = []

  const deepSearch = (o:any) => {
    Object.keys(o).forEach(key => {
      if (additionReg.test(key) && o[key]?.forEach) {
        o[key].forEach?.((v:any) => {
          if (combinationReg.test(key)) {
            combProductAdt.push(v)
          } else {
            productAdt.push(v)
          }
        })
      } else if (typeof o[key] === 'object' && o[key] != null) {
        deepSearch(o[key])
      }
    })
  }
  deepSearch(data)
  const getAdt = (await import('@/util/useData')).adt
  const getGpAdt = (await import('@/util/useData')).gpAdt
  const idSet = new Set<any>()
  const isIncluded = await Promise.all([getAdt(), getGpAdt(0)]).then(([adt, gpa]) => {
    const exclude = [[], [], [], []] as any[][]
    const ids = [productAdt, undefined, combProductAdt, undefined]
    const types = [adt.productAdditionList, adt.deliveryAdditionList, gpa.productAdditionList, gpa.deliveryAdditionList]
    types.forEach((adt, i) => {
      if (ids[i]) {
        ids[i]?.forEach(id => {
          const find = adt.find((v:any) => v.additionId.toString() === id.additionId.toString())
          if (!find) {
            const tag = JSON.stringify({ id, type: i })
            if (!idSet.has(tag)) {
              exclude[i].push(id)
              idSet.add(tag)
            }
          }
        })
      }
    })
    if (exclude.flat().length) {
      useComp({
        comp: DisableAdditionModal,
        props: {
          data: exclude
        }
      })
    } else {
      return true
    }
  })
  if (isIncluded) {
    return fn()
  } else {
    return { data: null }
  }
}
